import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import _ from 'lodash';
import {
  IS_LOADING,
  DRUG_FETCH,
  DRUG_CLEAR,
  MEDICAL_SUPPLY_FETCH,
  MEDICAL_SUPPLY_CLEAR
} from './types';

const fetchDrugList = async (dispatch, url, {
  fetchType = DRUG_FETCH,
  clearType = DRUG_CLEAR,
  loadingKey = 'DRUG_FETCH',
  dataKey = 'data',
  statusKey = 'status',
  messageKey = 'message'
} = {}) => {
  dispatch({ type: clearType });
  dispatch({ type: IS_LOADING, status: true, names: { [loadingKey]: true } });
  await axios.get(url).then(response => {
    const resData = response.data;
    const data = ((resData && resData.data) || []);
    let status = 'success';
    let message = '';
    if (resData.error || resData.errors) {
      status = 'error';
      message = resData.message || 'Unable to load medicine data';
    }
    dispatch({
      type: fetchType,
      playload: {
        [dataKey]: data,
        [statusKey]: status,
        [messageKey]: message
      }
    });
    dispatch({ type: IS_LOADING, status: false, names: { [loadingKey]: false } });
  }).catch(err => {
    let error = err;
    const message = err?.response?.data?.message || err?.response?.data?.error || err.message || 'Unable to load medicine data';
    dispatch({
      type: fetchType,
      playload: {
        [dataKey]: [],
        [statusKey]: 'error',
        [messageKey]: message
      }
    });
    dispatch({ type: IS_LOADING, status: false, names: { [loadingKey]: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const getDrugByRefCode = docCode => async dispatch => {
  const url = `drug/medicine?refCode=${docCode}`;

  await fetchDrugList(dispatch, url);
};

export const getDrugByInnoPharmacy = ({
  search = '',
  limit = 10
} = {}, company = {}) => async dispatch => {
  const params = new URLSearchParams({ limit: `${limit}` });

  if ((search || '').trim() !== '') {
    params.set('search', search.trim());
  }
  if (company?.companyCode) {
    params.set('companyCode', company.companyCode);
  }
  const url = `his_inno/pharmacy?${params.toString()}`;

  await fetchDrugList(dispatch, url);
};

export const getMedicalSupplyByInno = ({
  search = '',
  limit = 10
} = {}, company = {}) => async dispatch => {
  const params = new URLSearchParams({ limit: `${limit}` });

  if ((search || '').trim() !== '') {
    params.set('search', search.trim());
  }
  if (company?.companyCode) {
    params.set('companyCode', company.companyCode);
  }
  const url = `his_inno/medicalsupplies?${params.toString()}`;

  await fetchDrugList(dispatch, url, {
    fetchType: MEDICAL_SUPPLY_FETCH,
    clearType: MEDICAL_SUPPLY_CLEAR,
    loadingKey: 'MEDICAL_SUPPLY_FETCH',
    dataKey: 'medicalSupplyData',
    statusKey: 'medicalSupplyStatus',
    messageKey: 'medicalSupplyMessage'
  });
};

export const drugClear = () => dispatch => {
  dispatch({ type: DRUG_CLEAR });
  dispatch({ type: MEDICAL_SUPPLY_CLEAR });
};

export const bdsCreatePrescription = async refCode => {
  const url = 'drug/bds/createPrescription';
  return new Promise(reslove => {
    axios.post(url, { refCode }).then(response => {
      reslove(response.data);
    }).catch(error => {
      reslove(error);
    });
  });
};

export const getDrugByBds = params => async dispatch => {
  const url = `drug/bds/getProducts?${params.join('&')}`;

  dispatch({ type: DRUG_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { DRUG_FETCH: true } });
  await axios.get(url).then(response => {
    const resData = response.data;
    const data = ((resData && resData.data) || []);
    let status = 'success';
    if (resData.error || resData.errors) {
      status = 'error';
    }
    dispatch({ type: DRUG_FETCH, playload: { data, status } });
    dispatch({ type: IS_LOADING, status: false, names: { DRUG_FETCH: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { DRUG_FETCH: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const bdsCheckStock = async (refCode, items = []) => {
  const url = `drug/bds/checkStock/${refCode}`;
  return new Promise(reslove => {
    axios.post(url, { items }).then(response => {
      reslove(response.data);
    }).catch(error => {
      reslove(error);
    });
  });
};
